export default "<div class=\"dashboard\">\n    <app-customerlist *ngIf=\"authService.hasAccess(Role.PartnerAdmin)\"></app-customerlist>\n</div>\n"